import React, { Component } from 'react';
import { DeleteSquare, EditSquare } from 'jbc-front/components/icons';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import styles from './DeleteEditEmployeeBtn.scss';
import { withTranslation, useTranslation } from 'react-i18next';

export default withTranslation('translation')(class DeleteEditEmployeeBtn extends Component {
  state = {
    isModalOpen: false
  };

  closeModal = () => this.setState({ ...this.state, isModalOpen: false });

  render() {
    const { deletable, handleDelete, editUrl } = this.props;
    const header = this.props.t('features.Employees.components.DeleteEditEmployeeBtn.delete_employee_information');

    function Title() {
      const { t } = useTranslation();
      if (deletable) {
        return (
          <CommonModal.Body>
            <p>
              {t('features.Employees.components.DeleteEditEmployeeBtn.cannot_cancel_once_employee_information_is_deleted')}<br />
              {t('features.Employees.components.DeleteEditEmployeeBtn.Please_note_that_the_employee_account_will_also_be_deleted_and_you_will_not_be_able_to_login')}<br />
              <span className={styles.warning}>{t('features.Employees.components.DeleteEditEmployeeBtn.Are_you_sure_you_want_to_delete_this_employee')}</span>
            </p>
          </CommonModal.Body>
        );
      }
      return (
        <CommonModal.Body>
          <p className={styles.warning}>{t('features.Employees.components.DeleteEditEmployeeBtn.cannot_delete_because_there_is_salary_or_bonus_confirmation')}</p>
        </CommonModal.Body>
      );
    }
    return (
      <div className="u-ta-r u-mt30">
        <span
          className={styles.delete}
          role="presentation"
          onClick={() => this.setState({ ...this.state, isModalOpen: true })}
        >
          <DeleteSquare icon={16} />{this.props.t('features.Employees.components.DeleteEditEmployeeBtn.delete_employee')}
        </span>
        <span className={styles.edit}>
          <a href={editUrl}>
            <EditSquare icon={16} />{this.props.t('features.Employees.components.DeleteEditEmployeeBtn.go_to_employee_information_edit_page')}
          </a>
        </span>
        <CommonModal header={header} isOpen={this.state.isModalOpen} hideModal={this.closeModal} ariaHideApp={false}>
          <CommonModal.Header hideModal={this.closeModal}>{header}</CommonModal.Header>
          <Title />
          {deletable && (
            <CommonModal.Footer>
              <Button onClick={this.closeModal} className="u-mr20">
                {this.props.t('features.Employees.components.DeleteEditEmployeeBtn.no')}
              </Button>
              <Button
                onClick={() => {
                  handleDelete();
                  this.closeModal();
                }}
                primary
              >
                {this.props.t('features.Employees.components.DeleteEditEmployeeBtn.yes')}
              </Button>
            </CommonModal.Footer>
          )}
        </CommonModal>
      </div>
    );
  }
})
